export const DIRECTION_X = "horizontal";
export const DIRECTION_Y = "vertical";

export const SNAP_CENTER = "center";
export const SNAP_END = "end";
export const SNAP_START = "start";

export const ITEM_INDEX_PROP = "data-index";

export const translateProperties = {
  [DIRECTION_X]: "translateX",
  [DIRECTION_Y]: "translateY"
};
export const offsetProperties = {
  [DIRECTION_X]: "width",
  [DIRECTION_Y]: "height"
};
